import Card from "@rio-cloud/rio-uikit/Card";
import { useT } from "@hooks";

export interface HorizontalBarItem {
  label: string;
  value: number;
}

interface HorizontalBarListProps {
  title: string;
  items: HorizontalBarItem[];
  color: string;
}

const BAR_HEIGHT = 30;
const BAR_RADIUS = 4;
const BAR_OPACITY = 0.75;

const formatCurrency = (value: number) =>
  `R$ ${value.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export default function HorizontalBarList({ title, items, color }: Readonly<HorizontalBarListProps>) {
  const t = useT();
  const maxValue = items.reduce((max, item) => Math.max(max, item.value), 0);

  return (
    <Card className="padding-y-25 padding-x-15 padding-x-25-sm display-flex flex-column height-100pct">
      <div className="padding-bottom-20">
        <span className="text-size-16 text-bold">{title}</span>
      </div>
      <div
        data-testid="lista-barras"
        className="flex-1-1 display-flex flex-column justify-content-center gap-5 padding-15"
      >
        {items.length === 0 ? (
          <span className="text-center text-color-gray text-size-14">{t("common.label.noData")}</span>
        ) : (
          items.map((item) => {
            const percentage = maxValue > 0 ? (item.value / maxValue) * 100 : 0;
            return (
              <div key={item.label} className="display-flex align-items-center gap-10">
                <div
                  data-testid="trilho-horizontal"
                  className="position-relative flex-1-1 min-width-0 bg-lightest"
                  style={{ height: BAR_HEIGHT, borderRadius: BAR_RADIUS }}
                >
                  <div
                    data-testid="barra-horizontal"
                    style={{
                      width: `${percentage}%`,
                      height: BAR_HEIGHT,
                      borderRadius: BAR_RADIUS,
                      backgroundColor: color,
                      opacity: BAR_OPACITY,
                    }}
                  />
                  <div className="position-absolute left-0 top-0 display-flex align-items-center width-100pct height-100pct padding-x-10 min-width-0">
                    <span
                      className="text-size-14 text-normal text-color-black"
                      style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                      title={item.label}
                    >
                      {item.label}
                    </span>
                  </div>
                </div>
                <span className="text-size-14 text-color-darker white-space-nowrap">{formatCurrency(item.value)}</span>
              </div>
            );
          })
        )}
      </div>
    </Card>
  );
}
